export enum EExceptionStatus {
  New = 'new',
  Retriggered = 'retriggered',
  TicketAssigned = 'assigned',
  Ignored = 'ignored',
  Closed = 'closed',
}
